module.exports = __webpack_public_path__ + "img/sol.eff86127.svg";